module.exports = __webpack_public_path__ + "img/preheart_bg.736d3edd.png";